import React from 'react';
import styles from '../detail.module.scss';
import { formatCurrency } from '../formatCurrency';

interface MoneyAmount {
    currency: string;
    amount: number;
}

interface WalletCreditedContext {
    reference: string;
    amount: MoneyAmount;
    currentBalance: MoneyAmount;
    senderName: string;
    dateOfTransaction: string;
}

interface WalletCreditedDetailProps {
    context: WalletCreditedContext;
}

const formatDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
};

const formatTime = (dateStr: string): string => {
    const date = new Date(dateStr);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
};

const WalletCreditedDetail: React.FC<WalletCreditedDetailProps> = ({ context }) => {
    return (
        <div className={styles.container}>
            <div className={styles.infoBlock}>
                <div className={styles.row}>
                    <span className={styles.rowLabel}>Amount Credited</span>
                    <span className={styles.rowValueCredited}>
                        {formatCurrency(context.amount.amount, context.amount.currency)}
                    </span>
                </div>
<div className={styles.row}>
                    <span className={styles.rowLabel}>Current Balance</span>
                    <span className={styles.rowValue}>
                        {formatCurrency(context.currentBalance.amount, context.currentBalance.currency)}
                    </span>
                </div>
<div className={styles.row}>
                    <span className={styles.rowLabel}>From</span>
                    <span className={styles.rowValue}>{context.senderName}</span>
                </div>
<div className={styles.row}>
                    <span className={styles.rowLabel}>Date</span>
                    <span className={styles.rowValue}>
                        {`${formatDate(context.dateOfTransaction)} at ${formatTime(context.dateOfTransaction)}`}
                    </span>
                </div>
<div className={styles.row}>
                    <span className={styles.rowLabel}>Reference</span>
                    <span className={styles.rowValueMono}>{context.reference}</span>
                </div>
            </div>
        </div>
    );
};

export default WalletCreditedDetail;
